var _mask, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketQrImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 101,
    viewBox: "0 0 93 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_293_1474",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3452 1.23978e-05C55.3452 4.88509 51.3851 8.84522 46.5 8.84522C41.6149 8.84522 37.6548 4.88509 37.6548 1.23978e-05L27.2272 0C22.8089 0 19.2272 3.58172 19.2272 7.99999V80.4521C19.2272 84.8704 22.8089 88.4521 27.2272 88.4521L37.6548 88.4521C37.6548 83.567 41.6149 79.6069 46.5 79.6069C51.3851 79.6069 55.3452 83.567 55.3452 88.4521L65.7726 88.4521C70.1909 88.4521 73.7726 84.8704 73.7726 80.4521V8C73.7726 3.58172 70.1909 0 65.7726 0L55.3452 1.23978e-05Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3452 1.23978e-05L55.3452 -1.99999L53.3452 -1.99999V1.23978e-05H55.3452ZM37.6548 1.23978e-05H39.6548V-1.99999L37.6548 -1.99999L37.6548 1.23978e-05ZM27.2272 0L27.2272 -2H27.2272V0ZM27.2272 88.4521V90.4521H27.2272L27.2272 88.4521ZM37.6548 88.4521L37.6548 90.4521L39.6548 90.4521V88.4521H37.6548ZM55.3452 88.4521H53.3452V90.4521L55.3452 90.4521L55.3452 88.4521ZM65.7726 88.4521L65.7726 90.4521H65.7726V88.4521ZM65.7726 0V-2H65.7726L65.7726 0ZM46.5 10.8452C52.4896 10.8452 57.3452 5.98966 57.3452 1.23978e-05H53.3452C53.3452 3.78052 50.2805 6.84522 46.5 6.84522V10.8452ZM35.6548 1.23978e-05C35.6548 5.98966 40.5103 10.8452 46.5 10.8452V6.84522C42.7195 6.84522 39.6548 3.78052 39.6548 1.23978e-05H35.6548ZM27.2272 2L37.6548 2.00001L37.6548 -1.99999L27.2272 -2L27.2272 2ZM21.2272 7.99999C21.2272 4.68629 23.9135 2 27.2272 2V-2C21.7043 -2 17.2272 2.47715 17.2272 7.99999H21.2272ZM21.2272 80.4521V7.99999H17.2272V80.4521H21.2272ZM27.2272 86.4521C23.9135 86.4521 21.2272 83.7658 21.2272 80.4521H17.2272C17.2272 85.9749 21.7043 90.4521 27.2272 90.4521V86.4521ZM37.6548 86.4521L27.2272 86.4521L27.2272 90.4521L37.6548 90.4521L37.6548 86.4521ZM39.6548 88.4521C39.6548 84.6716 42.7195 81.6069 46.5 81.6069V77.6069C40.5103 77.6069 35.6548 82.4624 35.6548 88.4521H39.6548ZM46.5 81.6069C50.2805 81.6069 53.3452 84.6716 53.3452 88.4521H57.3452C57.3452 82.4624 52.4896 77.6069 46.5 77.6069V81.6069ZM65.7726 86.4521L55.3452 86.4521L55.3452 90.4521L65.7726 90.4521L65.7726 86.4521ZM71.7726 80.4521C71.7726 83.7658 69.0863 86.4521 65.7726 86.4521V90.4521C71.2955 90.4521 75.7726 85.9749 75.7726 80.4521H71.7726ZM71.7726 8V80.4521H75.7726V8H71.7726ZM65.7726 2C69.0863 2 71.7726 4.68629 71.7726 8H75.7726C75.7726 2.47715 71.2955 -2 65.7726 -2V2ZM55.3452 2.00001L65.7726 2L65.7726 -2L55.3452 -1.99999L55.3452 2.00001Z",
    fill: "#000",
    mask: "url(#path-1-inside-1_293_1474)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2272 20.6388H73.4041",
    stroke: "#000",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.6078,
    y: 32.6953,
    width: 8.31941,
    height: 8.31941,
    stroke: "#000",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6078,
    y: 58.4938,
    width: 8.31941,
    height: 8.31941,
    stroke: "#000",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5604,
    y: 58.4938,
    width: 8.31941,
    height: 8.31941,
    stroke: "#000",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5603,
    y: 32.6953,
    width: 8.31941,
    height: 8.31941,
    stroke: "#000",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4482 31.6953V67.8132",
    stroke: "#000",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3351 53.0712H44.2884V67.8132",
    stroke: "#000",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2883 42.0147L44.2883 31.6953",
    stroke: "#000",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3351 47.1743H44.2884",
    stroke: "#000",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6078 47.1743H64.9272",
    stroke: "#000",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6078 53.0712H64.9272",
    stroke: "#000",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6363 57.7022C84.3206 61.912 91.9545 68.8683 91.9545 76.7372C91.9545 89.5849 71.6038 100 46.5 100C21.3961 100 1.04541 89.5849 1.04541 76.7372C1.04541 69.1507 8.14119 62.4125 19.1214 58.166C19.6449 57.9635 20.1771 57.7667 20.7179 57.5758",
    stroke: "#000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketQrImage);
export default __webpack_public_path__ + "static/media/ticketQrImage.bddc7383d6b363dae907c7c1ac03454a.svg";
export { ForwardRef as ReactComponent };